// Single source of truth for the "add a school to this group" deep-link into the school
// wizard's adding-to-group mode. The wizard reads ?matId= and, on success, redirects back
// to /group-detail?matId= where the list reloads on mount.
export const registerSchoolForGroupPath = (matId) => `/register-school?matId=${matId}`;
